import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
  ${componentStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  .gallery-item {
    height: 100%;
    position: relative;
  }

  .gallery-item.no-image {
    background-color: var(--p-skeleton-bg);
  }

  .gallery-item.use-lightbox:not(.no-image) {
    cursor: zoom-in;
  }

  /**
--------------------------------------------------
* Image
--------------------------------------------------
*/

  .image {
    height: 100%;
    width: 100%;
    position: relative;
  }

  .image img {
    max-width: 100%;
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  /**
--------------------------------------------------
* Ratio
--------------------------------------------------
*/

  .ratio-none .image {
    aspect-ratio: auto;
  }

  .ratio-none .image img {
    height: auto;
  }

  .ratio-16-9 .image {
    aspect-ratio: 16/9;
  }

  .ratio-3-2 .image {
    aspect-ratio: 3/2;
  }

  .ratio-1-1 .image {
    aspect-ratio: 1/1;
  }

  .ratio-2-3 .image {
    aspect-ratio: 2/3;
  }
`;
